import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { CertificationComponent } from './component/certification.component';
import { ContractsModule } from '../../dossiers/contracts/contracts.module';

@NgModule({
  declarations: [CertificationComponent],
  imports: [
    CommonModule,
    FormPlycaModule,
    ContractsModule
  ],
  exports: [CertificationComponent]
})
export class CertificationModule {

}